export default __webpack_public_path__ + "static/media/emoji-bestest.52547832.svg";